export default "__VITE_ASSET__Aq892O$s__"